import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Card, CardBody, Col, Modal, ModalBody, Row } from "reactstrap";

import { Badge } from "@/components/Common/Badge";
import { ApproveButton, CancelButton, RejectButton, ReturnButton, } from "@/components/Common/Buttons";
import { DateTimeLabel } from "@/components/Common/DateTimeLabel";
import { DatePickerField, InputField } from "@/components/Common/Inputs";
import useCustomHook from "@/components/Hooks/useCustomHook";
import defaultTrxImg from "@/assets/images/default_transaction.png";
import { CurrencyInputField } from "@/components/Common/Inputs/CurrencyInputField";
import { PhotoViewer } from "@/components/Common/PhotoViewer";

import ActionModal from "./ActionModal";
import History from "./History";

import { useFindCashDisbursementsQuery } from "@/api/Endpoints/FMS/Transactions/CashDisbursement/CashDisbursements";

const profileBg = require(`@/${process.env.REACT_APP_CUSTOMER_USER_PROFILE}`);

const ViewDetails = ({ data, show = false, onCloseClick, parentKey, onUpdateParentKey }) => {
    const { state, customFunction } = useCustomHook();

    const { data: transactionData, refetch, isLoading } = useFindCashDisbursementsQuery({ cashDisbursementId: data?.cashDisbursementId }, { skip: !data?.cashDisbursementId, refetchOnMountOrArgChange: show });
    const findData = transactionData?.returnData;
    const {
        reset,
        control,
    } = useForm({ defaultValues: {} });

    useEffect(() => {
        reset({
            ...findData,
        });
        customFunction.updateState({
            data: {
                ...state, data,
                ...findData
            }
        })
    }, [show, data, findData, refetch, reset,]);

    const handleActions = (bool, data) => {
        if (bool) {
            customFunction.updateToggle("toggleAction");
            customFunction.updateToggle("refetchHistory");
            onUpdateParentKey(parentKey + 1)
        } else {
            customFunction.updateToggle("toggleAction", { ...findData, actionName: data });
        }
    };


    return (
        <React.Fragment>
            <ActionModal
                state={state}
                customFunction={customFunction}
                cashDisbursementId={findData?.cashDisbursementId}
                data={state?.trxValue}
                show={state.toggle.toggleAction}
                onCloseClick={handleActions}
            />

            <Modal
                className="modal-fullscreen"
                modalClassName="flip"
                id="requestDetails"
                size="xl"
                isOpen={show}
                toggle={onCloseClick}
                centered
                backdrop="static"
            >
                <ModalBody>
                    <div>
                        <div className="profile-foreground position-relative mx-n4 mt-n4">
                            <div className="profile-wid-bg" >
                                <picture>
                                    <source srcSet={profileBg} type="image/jpeg" />
                                    <img src={profileBg} alt="" className="profile-wid-img" />
                                </picture>
                            </div>
                            <button
                                type="button"
                                className="
    btn btn-icon btn-sm btn-ghost-danger fs-16
    position-absolute top-0 end-0 m-3
    d-lg-none
  "
                                style={{ zIndex: 1055 }}
                                onClick={onCloseClick}
                            >
                                X
                            </button>
                        </div>
                        <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                            <Row className="g-4">

                                <div className="col-md-auto">
                                    <PhotoViewer>
                                        <img src={defaultTrxImg} style={{ width: "100px", height: "80px", cursor: 'pointer' }} />
                                    </PhotoViewer>
                                </div>

                                <Col style={{ paddingLeft: "0px" }}>
                                    <div>
                                        <h3 className="text-white mb-1">Cash Disbursement Request Details</h3>
                                        <p className="text-white text-opacity-75">
                                            Date {state.data?.statusName}:{" "}
                                            <span className="fw-semibold">
                                                {(
                                                    <DateTimeLabel
                                                        value={state.data?.statusDate}
                                                    />
                                                ) || "Draft"}
                                            </span>{" "}
                                            <Badge
                                                value={state.data?.statusName}
                                                color={state.data?.statusColor}
                                            />
                                            <br />
                                            Reference No. : <span className="fs-16 fw-semibold" style={{ color: '#0ab39c' }}>{findData?.referenceNo}</span>
                                        </p>
                                    </div>
                                </Col>

                                <Col
                                    xs={12}
                                    lg="auto"
                                    className="order-last order-lg-0 d-none d-lg-flex align-items-start"
                                >
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-sm btn-ghost-danger fs-16 mt-4 mt-lg-0"
                                        onClick={onCloseClick}
                                    >
                                        X
                                    </button>
                                </Col>
                            </Row>
                        </div>

                        <Row>
                            <Col xxl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={6}>
                                                <Card>
                                                    <CardBody>
                                                        <Row className="align-items-center gy-2">
                                                            <Col lg={8} xs={12}>
                                                                <h5 className="card-title mb-0 text-center text-lg-start">
                                                                    Request Details
                                                                </h5>
                                                            </Col>

                                                            <Col lg={4} xs={12}>
                                                                <div
                                                                    className="
                                                                                         d-flex
                                                                                         justify-content-center justify-content-lg-end
                                                                                         gap-1
                                                                                         mt-2 mt-lg-0
                                                                                       "
                                                                >
                                                                    <ReturnButton
                                                                        isShowButton={state.data?.actions?.return}
                                                                        onClick={() => handleActions(false, "Return")}
                                                                    />
                                                                    <ApproveButton
                                                                        isShowButton={state.data?.actions?.approve}
                                                                        onClick={() => handleActions(false, "Approve")}
                                                                    />
                                                                    <RejectButton
                                                                        isShowButton={state.data?.actions?.reject}
                                                                        onClick={() => handleActions(false, "Reject")}
                                                                    />
                                                                    <CancelButton
                                                                        isShowButton={state.data?.actions?.cancel}
                                                                        onClick={() => handleActions(false, "Cancel")}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <br />
                                                        <Row className="mt-2">
                                                            <Col lg={6}>
                                                                <InputField
                                                                    disabled
                                                                    name="payee"
                                                                    control={control}
                                                                    label="Payee"
                                                                    type="text"
                                                                    rules={{
                                                                        required: "Payee is required",
                                                                    }}
                                                                    placeholder="Enter payee...."
                                                                />
                                                            </Col>
                                                            <Col lg={6}>
                                                                <CurrencyInputField
                                                                    disabled
                                                                    name="amount"
                                                                    control={control}
                                                                    label="Amount"
                                                                    rules={{
                                                                        required: "Payee is required",
                                                                    }}
                                                                    placeholder="Enter payee...."
                                                                />
                                                            </Col>

                                                            <Col lg={12}>
                                                                <InputField
                                                                    disabled
                                                                    rows={4}
                                                                    name="remarks"
                                                                    control={control}
                                                                    label="Remarks"
                                                                    type="textarea"
                                                                    placeholder="Remarks here..."
                                                                />
                                                            </Col>

                                                            <div className="col-12">
                                                                <hr className="pb-2" />
                                                            </div>

                                                            <Col lg={6}>
                                                                <DatePickerField
                                                                    control={control}
                                                                    name="dateSubmitted"
                                                                    label="Date Submitted"
                                                                    disabled
                                                                />
                                                            </Col>
                                                            <Col lg={6}>
                                                                <InputField
                                                                    control={control}
                                                                    name="submittedByName"
                                                                    label="Submitted By"
                                                                    disabled
                                                                />
                                                            </Col>
                                                            {findData?.statusName !== "Submitted" ? (
                                                                <>
                                                                    <Col lg={6}>
                                                                        <DatePickerField
                                                                            control={control}
                                                                            name="statusDate"
                                                                            label={`Date ${findData?.statusName}`}
                                                                            disabled
                                                                        />
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <InputField
                                                                            control={control}
                                                                            name="statusByName"
                                                                            label={`${findData?.statusName} By`}
                                                                            disabled
                                                                        />
                                                                    </Col>
                                                                </>
                                                            ) : null}
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>

                                            <Col lg={6}>
                                                <History
                                                    key={state.toggle.refetchHistory}
                                                    parentId={data?.cashDisbursementId}
                                                />
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default ViewDetails;
